<button class="flex-initial h-8 w-8 bg-black rounded-full grid items-center justify-items-center" (click)="onClick()">
  <img [src]="icon()" class="max-h-5 max-w-5" style="filter: brightness(0) saturate(100%) invert(100%) sepia(100%) saturate(0%) hue-rotate(229deg) brightness(107%) contrast(106%);">
</button>
